<template>
  <div>
    <selfBrand
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-01-品牌实力'"
    />
    <selfWhat
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-02-学历文凭有什么用'"
    />
    <selfAdvantage
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-03-自考优势'"
    />
    <selfFirst
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-04-自考上岸无忧'"
    />
    <selfDoubts
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-05-顾虑太多'"
    />
    <selfNews
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-自考-06-新闻中心'"
    />
    <websiteAbout
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-公司-01-单图'"
    />
    <webAbout
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-关于我们（新）'"
    />
    <webSquare
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-四方联动（新）'"
    />
    <webOperate
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-合作企业（新）'"
    />
    <webPartners
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-合作院校（新）'"
    />
    <webHonor
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-集团荣誉（新）'"
    />
    <webDevelop
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '公司官网-发展历程（新）'"
    />
    <websiteDevelop
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-公司-02-发展历程'"
    />
    <websiteNews
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-公司-03-集团新闻'"
    />
    <websiteBusiness
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-公司-04-旗下业务'"
    />
    <vocationCop
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-公司-05-战略合作'"
    />
    <vocationfusion
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-职教-01-产教融合'"
    />
    <vocationDep
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-职教-02-人才培养'"
    />
    <vocationConcat
      :menuId="menuId"
      :pageType="pageType"
      v-if="pageType === '首页模板-职教-03-联系我们'"
    />
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import selfBrand from "./selfBrand.vue";
import selfWhat from "./selfWhat.vue";
import selfAdvantage from "./selfAdvantage.vue";
import selfFirst from "./selfFirst.vue";
import selfNews from "./selfNews.vue";
import selfDoubts from "./selfDoubts.vue";
import websiteAbout from "./websiteAbout.vue";
import webAbout from "./webAbout.vue";
import webSquare from "./webSquare.vue";
import webOperate from "./webOperate.vue";
import webPartners from "./webPartners.vue";
import webHonor from "./webHonor.vue";
import websiteDevelop from "./websiteDevelop.vue";
import websiteBusiness from "./websiteBusiness.vue";
import websiteNews from "./websiteNews.vue";
import webDevelop from "./webDevelop.vue";
import vocationCop from "./vocationCop.vue";
import vocationfusion from "./vocationfusion.vue";
import vocationDep from "./vocationDep.vue";
import vocationConcat from "./vocationConcat.vue";
export default {
  mixins: [pageMain_mx],
  data() {
    return {};
  },
  props: {
    pageType: {
      type: String,
      default: ""
    },
    menuId: {
      type: String,
      default: ""
    }
  },
  components: {
    selfWhat,
    selfAdvantage,
    selfNews,
    selfFirst,
    selfDoubts,
    websiteAbout,
    websiteDevelop,
    websiteNews,
    websiteBusiness,
    webAbout,
    webOperate,
    webHonor,
    webDevelop,
    vocationCop,
    webPartners,
    vocationfusion,
    vocationDep,
    vocationConcat,
    webSquare,
    selfBrand
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less"></style>
